import { IAttachedFile } from '../../../redux/types/IAttachedFile';
import IFile from '../../../redux/types/IFiles';
import { StorageService } from '../../services/StorageService';
import { ERROR_OBTAINING_SAS, ERROR_UPLOADING_FILE_SAS, OBTAINED_SAS, REQUEST_SAS, UPLOADING_FILE_SAS, UPLOAD_COMPLETED } from './ContainerDetailsWindowFields';
import { ContainerDetailsWindow } from './ContainerDetailsWindow';

export class LivePerformanceContainerDetailsWindow extends ContainerDetailsWindow {

    componentDidMount() {
        super.componentDidMount();
		this.props.cleanUploadFilesState?.();
		this.props.cleanDroppedFilesRepertoire?.();
    }

    uploadFile(newFile: IFile, path: string, file: any) {
        const {
            addFileToUpload, 
            setProgressUploadFileProccess,
            setInDropZone
        } = this.props;

        addFileToUpload(newFile, true);

        setInDropZone(false);

        setProgressUploadFileProccess(this.viewData[REQUEST_SAS], newFile, false);

        return Promise.resolve(
            StorageService.getUploadUri(path, true).then(
                (uri: string) => {
                    if (uri && uri.length > 0) {
                        setProgressUploadFileProccess(this.viewData[OBTAINED_SAS], newFile, false);
                        setProgressUploadFileProccess(this.viewData[UPLOADING_FILE_SAS], newFile, false);
                    
                        return StorageService.uploadFile(uri, file).then(
                            (res: boolean) => {
                                if (res) {
                                    setProgressUploadFileProccess(this.viewData[UPLOAD_COMPLETED], newFile, true);
                                    return true;
                                }
                            },
                            reject => {
                                setProgressUploadFileProccess(this.viewData[ERROR_UPLOADING_FILE_SAS], newFile, true);

                                return false;
                            }
                        )
                            .catch(error => {
                                return false;
                            })
                    }
                },
                reject => {
                    setProgressUploadFileProccess(this.viewData[ERROR_OBTAINING_SAS], newFile, true);

                    return false;
                }
            )
        )
    }

    handleDrop = e => {
        const {
            cleanUploadFilesState,
            addRepertoireAttachmentToState,
            removeAttachmentIfExists,
            entitySource
        } = this.props;

        const files = [...e.dataTransfer.files];

        cleanUploadFilesState();

        files.forEach(file => {

            const newFile: IFile = super.createUploadFile(file);
            const fileToUpload: IFile = { ...newFile };
            fileToUpload.name = crypto.randomUUID();
            let fullPath: string = "";
            
            fullPath = `repertoireAttachments/usage/${fileToUpload.name}`;

            this.uploadFile(newFile, fullPath, file).then(
                (uploaded: boolean) => {
                    const finalFile:IAttachedFile={
                        fileName: file.name,
                        guid:fileToUpload.name
                    };
                    if (!uploaded) {
                        removeAttachmentIfExists(finalFile, entitySource);
                    }
                    else {                        
                        addRepertoireAttachmentToState(finalFile);
                    }
                }
            )
        });
        
        e.preventDefault();
    };
}